import React, { useState, useRef } from 'react'
import { isLoaded, useFirebase } from 'react-redux-firebase'
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  CardHeader,
  CardText,
  Button,
  Spinner,
  // Modal,
  // ModalBody,
  FormGroup,
  Label,
  Input,
  Alert,
} from 'reactstrap'
// import Autocomplete, { usePlacesWidget } from "react-google-autocomplete"
import Collapse from '@material-ui/core/Collapse'
import { Redirect, useHistory } from 'react-router-dom'
import { connect } from 'react-redux'
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft'
// import Checkbox from '@material-ui/core/Checkbox'
import { useTranslation } from 'react-i18next'
import ExpandLessIcon from '@material-ui/icons/ExpandLess'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'

import moment from 'moment'
import 'moment/locale/fi'
import { Divider } from '@material-ui/core'
import PaymentRedirect from './PaymentRedirect'
import PaymentOptions from './PaymentOptions'
import { useEffect } from 'react'
import { compose } from 'redux'
import { firestoreConnect } from 'react-redux-firebase'
import withAppconfig from '../AppContext'
import { useCookies } from 'react-cookie'
import { getAffiliate, AFFILIATE_COOKIE } from '../utils/affiliate'
import GuestContactForm from '../components/GuestContactForm'
import Payments from '../components/Payments'
import { getWallet } from '../components/ViewUtils'
import ExtraProduct from '../components/ExtraProduct'
import ExtraResource from '../components/ExtraResource'
import useWindowDimensions from '../useWindowsDimensions'
import OrganisationSelect from '../components/OrganisationSelect'
import { useUiGet } from '../utils/useUiGet'
import { membershipIdsFor as memberIdsFor, membershipKey } from '../utils/memberPricing'
import { isReservationEndInPast, isValidMultiAmount, pricedResourceId } from '../components/ReservationUtil'
// import CheckoutItem from '../components/CheckoutItem'
import ReservationItem from '../components/Reservationtem'
import TermsModal from '../components/TermsModal'
// import AccountSelector from '../components/AccountSelector'
import AmountOfReseourcesSelection from '../components/AmountOfReseourcesSelection'

const mapStateToProps = (state, props) => {
  const {
    reservation: { selected },
    firebase: { auth, profile },
    firestore,
    globaltime: { gtime },
  } = state
  const { appconfig } = props
  let cashsum = 0
  let sportmoneysum = 0
  let cashstoragesum = 0
  let minutestoragesum = 0
  let bl = false
  let blMessage = null
  let allowpostpayment = false
  const rows = []

  const postpaydetails =
    profile.firstname &&
    profile.lastname &&
    profile.email &&
    profile.streetaddress &&
    profile.streetaddress.trim().length > 6 &&
    profile.zip &&
    profile.zip.trim().length === 5 &&
    !isNaN(parseInt(profile.zip)) &&
    profile.city &&
    profile.city.trim().length > 1

  if (appconfig.cashierpayment) allowpostpayment = true

  if (firestore.data['acls'] && firestore.data['acls'].default) {
    bl = firestore.data['acls'].default.blocked ? firestore.data['acls'].default.blocked : false
    if (bl) blMessage = firestore.data['acls'].default.blockedMessage || null
    allowpostpayment = firestore.data['acls'].default.allowpostpayment || false
  }

  if (firestore.data['wallets'] && selected) {
    let wallet = []
    const walletName = getWallet(appconfig, selected)
    if (firestore.data['wallets'] && firestore.data['wallets'][walletName]) {
      wallet = firestore.data['wallets'][walletName]
    }

    cashsum =
      wallet && wallet.cash
        ? wallet.cash.reduce((acc, curr) => {
            acc = acc + curr.amount
            return acc
          }, 0)
        : 0

    sportmoneysum =
      wallet && wallet.sportmoney
        ? wallet.sportmoney.reduce((acc, curr) => {
            acc = acc + curr.amount
            return acc
          }, 0)
        : 0
  }

  if (firestore.data['storages'] && selected) {
    let storage = []
    if (firestore.data['storages'].default) {
      storage = firestore.data['storages'].default
    }

    cashstoragesum =
      storage && storage.cash
        ? storage.cash.reduce((acc, curr) => {
            acc = acc + curr.amount
            return acc
          }, 0)
        : 0

    minutestoragesum =
      storage && storage.minutes
        ? storage.minutes.reduce((acc, curr) => {
            acc = acc + curr.amount
            return acc
          }, 0)
        : 0
  }

  // check if selected is array  
  if (selected && Array.isArray(selected)) {
    console.log('selected is array')
    console.log(selected)
    rows.push(...selected)
  }



  const _membrss = Object.keys(firestore.data.memberships || {}).filter((x) => x !== 'undefined' && x !== 'null').map((k) => firestore.data.memberships[k]).filter((v) => v.permanent || gtime.isBetween(moment.utc(v.start), moment(v.end), 'day', '[]'))

  let _organisations = []
  if (firestore.data.organisations && firestore.data.organisations.reservation) {
    _organisations = firestore.data.organisations.reservation.map((v) => {
      return { id: v.organisationId, name: v.name, type: 'organisation' }
    })
  }

  console.log('Memberships DDD:', _membrss)

  return {
    auth,
    profile,
    gtime,
    wallet: firestore.data['wallets'] || [],
    cashsum,
    sportmoneysum,
    cashstoragesum,
    minutestoragesum,
    memberships: _membrss,
    mems: firestore.data.memberships,
    selected,
    allowpostpayment,
    postpaydetails,
    bl,
    blMessage,
    acls: firestore.data['acls'],
    organisations: _organisations,
    rows
  }
}

const enhance = compose(
  connect((state) => ({ auth: state.firebase.auth })),
  firestoreConnect((props) => [
    {
      collection: 'users',
      doc: `${props.auth.uid}`,
      subcollections: [
        { collection: 'paymentinfo', doc: 'saldo', subcollections: [{ collection: `${props.appconfig.accountkey}` }] },
      ],
      storeAs: 'wallets',
    },
    {
      collection: 'users',
      doc: `${props.auth.uid}`,
      subcollections: [
        { collection: 'memberships', doc: 'active', subcollections: [{ collection: `${props.appconfig.accountkey}` }] },
      ],
      storeAs: 'memberships',
    },
    {
      collection: 'users',
      doc: `${props.auth.uid}`,
      subcollections: [
        { collection: 'acls', doc: 'active', subcollections: [{ collection: `${props.appconfig.accountkey}` }] },
      ],
      storeAs: 'acls',
    },
    {
      collection: 'users',
      doc: `${props.auth.uid}`,
      subcollections: [
        { collection: 'organisations', doc: `${props.appconfig.accountkey}` },
      ],
      storeAs: 'organisations',
    },
  ]),
  connect(mapStateToProps)
)

function PriceRow({
  pricescheck,
  membershipprices,
  selected,
  t,
  ignorecourtprice,
  multipleamount
}) {
  const multiplier = (multipleamount && multipleamount > 1) ? multipleamount : 1
  console.log('PriceRow', ignorecourtprice, pricescheck, membershipprices, selected, multipleamount)
  if (ignorecourtprice) {
    console.log('ignoring court price')
    return null
  }
  if (pricescheck) {
    console.log('loading prices...')
    return <Spinner size='sm' />
  } else if (membershipprices && membershipprices.length > 0) {
    return membershipprices.map((p, i) => {
      const pr = p.price * multiplier
      return (
        <Row key={'membership-prices-' + i} className={'loose'}>
          <Col>{p.pricing === 'general' ? t('price') : p.pricing}</Col>
          <Col className={'text-right'}>
            {i >= 1 ? (
              <s>{pr.toFixed(2).replace('.', ',')} €</s>
            ) : (
              pr.toFixed(2).replace('.', ',') + ' €'
            )}
            {p.lastminute ? ' ' + t('lastminute_discount') : ''}
          </Col>
        </Row>
      )
    })
  } else if (selected) {
    const pr = selected.price * multiplier
    return (
    <Row className={'loose'} key={'price'}>
      <Col>{t('price')}</Col>
      <Col className={'text-right'}>
        {pr.toFixed(2).replace('.', ',')} €
      </Col>
      </Row>
    )
  }
  return null
}

const ReservationScreen = ({
  auth,
  profile,
  selected,
  cashsum,
  sportmoneysum,
  cashstoragesum,
  minutestoragesum,
  wallet,
  dispatch,
  memberships,
  mems,
  appconfig,
  bl,
  blMessage,
  allowpostpayment,
  postpaydetails,
  acls,
  organisations,
  rows,
  gtime,
}) => {
  const firebase = useFirebase()
  let history = useHistory()
  const { t } = useTranslation()
  const uiGet = useUiGet({ appconfig })
  // const [screen, setScreen] = useState('login')
  // eslint-disable-next-line no-unused-vars
  const [loading, setLoading] = useState(false)
  const [redirect, setRedirect] = useState(false)
  const [renderPayments, setRenderPayments] = useState(false)
  // const [token, setToken] = useState(null)
  const [payments, setPayments] = useState(null)
  const [errorNotification, setErrorNotification] = useState(null)
  // eslint-disable-next-line no-unused-vars
  const [cashwalletpayment, setCashwalletPayment] = useState(false)
  // const [sportmoneywalletpayment, setSportmoneywalletPayment] = useState(false)
  // const [cashstorepayment, setCashstorePayment] = useState(false)
  // const [minutestorepayment, setMinutestorePayment] = useState(false)
  // const [onlinepayment, setOnlinePayment] = useState(false)
  // const [cashierpayment, setCashierPayment] = useState(false)
  const [membershipprices, setMembershipPrices] = useState(null)
  const [orgMemberships, setOrgMemberships] = useState(null)
  // eslint-disable-next-line no-unused-vars
  const [initdone, setInitDone] = useState(false)
  const [pricescheck, setPricesCheck] = useState(true)
  const [pricescheckrd, setPricesCheckRd] = useState(false)
  // const [streetaddress, setStreetAddress] = useState(profile.streetaddress)
  // const [zip, setZip] = useState(profile.zip)
  // const [city, setCity] = useState(profile.city)
  const [usernote, setUserNote] = useState(null)
  const [guestInfoSaved, setGuestInfoSaved] = useState(false)
  const [guestBookingDone, setGuestBookingDone] = useState(false)
  const [cookies] = useCookies([AFFILIATE_COOKIE])
  const [giftcode, setGiftcode] = useState(null)
  const [giftcodeOpen, setGiftcodeOpen] = useState(false)
  const [giftcoderedeem, setGiftcoderedeem] = useState(null)
  const [checkingGiftcode, setCheckingGiftcode] = useState(false)
  // const [savingAddress, setSavingAddress] = useState(false)
  const [selectedmembership, setSelectedmembership] = useState(null)
  // The membership list getPrice served alongside the prices, kept so updateItemPricing filters
  // against the same thing getPrices did. Without it the giftcode path re-filters on the redux
  // copy alone and drops membership prices the backend had already granted.
  const [servedMemberships, setServedMemberships] = useState(null)
  // The membership list (membershipKey) the last getPrices filtered against.
  const pricedWithKey = useRef(null)
  const [onlinepaymentprovider, setOnlinePaymentProvider] = useState(null)
  const [checksum, setChecksum] = useState(null)
  const [items, setItems] = useState([])
  // eslint-disable-next-line no-unused-vars
  const [extraItems, setExtraItems] = useState({})
  // eslint-disable-next-line no-unused-vars
  const [extraItemsPrice, setExtraItemsPrice] = useState(0)
  const [createdReservation, setCreatedReservation] = useState(null)
  const { width } = useWindowDimensions()
  const [tcmodal, setTcModal] = useState(false)
  const tcToggle = () => setTcModal(!tcmodal)
  const [multiAmounts, setMultiAmounts] = useState(1)
  const [disabledSelections, setDisabledSelections] = useState(false)

  // [
  //   { id:'a',  value: 'person-a', label: { fi: 'Henkilökohtainen' } },
  //   { id: 'b', value: 'organisation-a', type: 'organisation', label: { fi: 'Yritys A' } },
  //   { id: 'c', value: 'organisation-b', type: 'organisation', label: { fi: 'Yritys B' } },
  // ]
  // )
  // eslint-disable-next-line no-unused-vars
  const [account, setAccount] = useState(null)


  const handleMultiAmountsChange = (value) => {
    selected.multiamount = value
    setMultiAmounts(value)
  }

  const unallowedmethods = [] //['benefitcard']
  if (!appconfig.storage) {
    if (!appconfig.summerstorage) {
      unallowedmethods.push('cashstore')
    }
  }

  if (!appconfig.cashierpayment) {
    unallowedmethods.push('cashier')
  }
  // console.log('ReservationScreen', unallowedmethods)
  const isBusiness = account ? account.type === 'organisation' : false

  // The membership ids to price against, for BOTH getPrices and updateItemPricing - they filter
  // the same rows and must not answer differently.
  //
  // `served` (prices.data.memberships, handed back by getPrice) wins over the redux copy: the
  // redux slice can be empty when it has not loaded, and filtering against an empty list denies a
  // membership price the backend had already granted. Both shapes are tolerated because the
  // served list is an array and the redux one has been both an array and an object.
  const membershipIdsFor = (served) => memberIdsFor({ served, memberships, isBusiness, orgMemberships })
  if (isBusiness) {
    unallowedmethods.push('cashwallet')
    unallowedmethods.push('cashstore')
    unallowedmethods.push('sportmoneywallet')
    unallowedmethods.push('minutestore')
  }
  // guest (anonymous auth) checkout: online payment only
  const isGuestCheckout = Boolean(auth && auth.isAnonymous)
  if (isGuestCheckout) {
    unallowedmethods.push('cashier', 'cashwallet', 'sportmoneywallet', 'cashstore', 'minutestore', 'benefitcard')
  }
  // several merged-court places: minutes cannot be split between the places, and createmultiv3
  // refuses them (MERGED_UNSPLITTABLE_METHODS). A benefit card can pay them -- one use per place.
  if (selected && selected.multiresource && multiAmounts > 1) {
    unallowedmethods.push('minutestore')
  }
  const guestProfileComplete = Boolean(
    profile && profile.email && profile.firstname && profile.lastname && profile.phone
  )
  const guestReady = !isGuestCheckout || guestInfoSaved || guestProfileComplete
  if (!selected) {
    history.push(appconfig.pathPrefix + '/')
  }

  const loaded = isLoaded(profile) && isLoaded(wallet) && isLoaded(mems) && isLoaded(acls)
  const setPaymentProvider = (p) => setOnlinePaymentProvider(p)
  const setPaymentSummary = (sportmoneywallet, cashwallet, online, cashier, cashstore) => {
    const checkedPayments = []
    const selectedPrice = selected.price * 100
    let leftToPay = selectedPrice
    if (sportmoneysum > 0) {
      let charged = 0
      if (sportmoneywallet) {
        if (leftToPay <= sportmoneysum) {
          charged = leftToPay
          leftToPay = 0
        } else {
          charged = sportmoneysum
          leftToPay = leftToPay - sportmoneysum
        }
        checkedPayments.push({ type: 'sportmoneywallet', charged })
      }
    }
    if (cashsum > 0) {
      // console.log('cashsum', cashsum, 'leftToPay', leftToPay)
      let charged = 0
      if (cashwallet && leftToPay > 0) {
        if (leftToPay <= cashsum) {
          charged = leftToPay
          leftToPay = 0
        } else {
          charged = cashsum
          leftToPay = leftToPay - cashsum
        }
        checkedPayments.push({ type: 'cashwallet', charged })
      }
    }
    if (cashstoragesum > 0) {
      // console.log('cashstore', cashstore, 'cashstoragesum', cashstoragesum, 'leftToPay', leftToPay)
      let charged = 0
      if (cashstore && leftToPay > 0) {
        if (leftToPay <= cashstoragesum) {
          charged = leftToPay
          leftToPay = 0
        } else {
          charged = cashstoragesum
          leftToPay = leftToPay - cashstoragesum
        }
        checkedPayments.push({ type: 'cashstore', charged })
      }
    }
    if (leftToPay > 0 && online) {
      checkedPayments.push({ type: 'paytrail', charged: leftToPay })
    } else if (leftToPay > 0 && cashier) {
      checkedPayments.push({ type: 'cashier', charged: leftToPay })
    } else {
      // checkedPayments.push({ type: 'cashier', charged: 0 })
      // checkedPayments.push({ type: 'paytrail', charged: 0 })
    }
    setPayments(checkedPayments)
  }

  const toggleGiftcode = () => {
    if (giftcodeOpen) setGiftcode(null)
    setGiftcodeOpen(!giftcodeOpen)
  }

  // Re-prices the list after a gift code is added to it. Deliberately the same filter as
  // getPrices below: it re-runs over rows getPrices already accepted, so answering differently
  // here would silently withdraw a price the user was just shown.
  const updateItemPricing = (prices) => {
    if (prices && prices.length > 0) {
      prices.sort((a, b) => a.price - b.price)
    }
    const membershipids = membershipIdsFor(servedMemberships)
    const membershipprices = prices.filter((x) => {
      if (x.membershipid) {
        return membershipids.includes(x.membershipid)
      } else {
        return true
      }
    })
    if (membershipprices && membershipprices.length > 0) {
      selected.price = membershipprices[0].price
    }
    if (membershipprices.length > 1) {
      selected.overridecost = true
      const gen = membershipprices.find((x) => x.pricing === 'general')
      selected.general = gen
      // selectedmembership is deliberately left as getPrices set it: a gift code always adds an
      // 'Etukoodi' row, which is not a membership, and the code itself travels in `giftcode`.
    }
    setMembershipPrices(membershipprices)
  }

  const getOrganisationMemberships = (slot) => {
    if (account && account.type === 'organisation') {
      uiGet({ q:'getOrganisationMemberships', organisation: account, customerid: appconfig.accountkey }).then((memberships) => {
        const orgMemberships = []
        if (memberships.data) {
          memberships.data.forEach((m) => {
            orgMemberships.push(m)
          })
        }
        setOrgMemberships(orgMemberships)
      })
    }
  }

  const getPrices = (_slot) => {
    console.log('getPrices', account)
    setPricesCheck(true)
    pricedWithKey.current = membershipKey(memberships)
    // A merged court is priced as its first free member court (pricedResourceId). The members are
    // priced alike, which is what makes showing them as one court honest.
    const slot = { ..._slot, resourceId: pricedResourceId(selected) || _slot.resourceId }
    uiGet({ q: 'getPrice', slot, personid: auth.uid, customerid: appconfig.accountkey, organisation: account ? account.id : 'personal' }).then((prices) => {
      if (prices.data && prices.data.prices && prices.data.prices.length > 0) {
        prices.data.prices.sort((a, b) => a.price - b.price)
      }
      const served = (prices.data && prices.data.memberships) || null
      // Kept for updateItemPricing, which runs later with no access to this response.
      if (served) setServedMemberships(served)
      const membershipids = membershipIdsFor(served)

      let membershipprices = prices.data.prices.filter((x) => {
        if (x.membershipid) {
          return membershipids.includes(x.membershipid)
        } else {
          return true
        }
      })
      if (membershipprices && membershipprices.length > 0) {
        selected.price = membershipprices[0].price
      }
      if (membershipprices.length > 1) {
        selected.overridecost = true
        const gen = membershipprices.find((x) => x.pricing === 'general')
        selected.general = gen
        setSelectedmembership(membershipprices[0].pricing)
      }
      console.log('selected', selected)
      setMembershipPrices(membershipprices)
      setPricesCheck(false)
      setPricesCheckRd(false)

      if (cashsum > 0 || sportmoneysum > 0) {
        setPaymentSummary(false, true, false, false, false)
        setCashwalletPayment(true)
      } else {
        setPaymentSummary(false, false, false, false, false)
      }
      setInitDone(true)
    })
  }

  const getChecksum = (slot) => {
    firebase.functions().region = 'europe-west1'
    const getchecksum = firebase.functions().httpsCallable('reservations-createChecksum')
    getchecksum({ slot, personid: auth.uid, customerid: appconfig.accountkey }).then((checksum) => {
      setChecksum(checksum.data.checksum)
    })
  }

  useEffect(() => {
    const slot = {
      resourceId: selected.resourceId,
      start: selected.start,
      end: moment(selected.start).utc().add(selected.duration, 'minutes').format(),
    }
    if (selected.od) {
      slot.end = moment(selected.start).utc().add(selected.od, 'minutes').format()
    }
    getPrices(slot)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orgMemberships])


  useEffect(() => {
    if (!membershipprices && selected && !pricescheckrd && isLoaded(memberships)) {
      setPricesCheckRd(true)
      const slot = {
        resourceId: selected.resourceId,
        start: selected.start,
        end: moment(selected.start).utc().add(selected.duration, 'minutes').format(),
      }
      if (selected.od) {
        slot.end = moment(selected.start).utc().add(selected.od, 'minutes').format()
      }
      getPrices(slot)
      getChecksum(slot)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [memberships])

  // The first getPrice usually runs before the Firestore listener has delivered the customer's
  // memberships, and then filters against an empty list: every member price dropped, full price
  // shown, and the effect above never prices again because membershipprices is already set. So
  // price again whenever the membership list changes - unless getPrice served its own list, which
  // already answered for it (utils/memberPricing.js).
  const memberKey = membershipKey(memberships)
  useEffect(() => {
    if (!memberKey || !membershipprices || servedMemberships || isBusiness || !selected) return
    // already priced against this very list (also covers the list arriving mid-request)
    if (pricedWithKey.current === memberKey) return
    const slot = {
      resourceId: selected.resourceId,
      start: selected.start,
      end: moment(selected.start).utc().add(selected.duration, 'minutes').format(),
    }
    if (selected.od) {
      slot.end = moment(selected.start).utc().add(selected.od, 'minutes').format()
    }
    getPrices(slot)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [memberKey, membershipprices])

  useEffect(() => {
    // console.log('useEffect selected addViewCounter', selected)
    if (selected && selected.view) {
      uiGet({ q: 'addViewCounter', personid: auth.uid, customerid: appconfig.accountkey, view: selected.view })
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selected])

  useEffect(() => {
    // console.log('Extras')

    // Extras are set up per real court, like prices: a merged court asks for its priced member's.
    const slot = {
      resourceId: pricedResourceId(selected),
      start: selected.start,
      end: moment(selected.start).utc().add(selected.duration, 'minutes').format(),
    }
    uiGet({ q: 'getExtras', personid: auth.uid, customerid: appconfig.accountkey, slot, v: 2 }).then((items) => {
      setItems(items.data)
      // console.log('Extras', items.data)
    })
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    // const slot = {
    //   resourceId: selected.resourceId,
    //   start: selected.start,
    //   end: moment(selected.start).utc().add(selected.duration, 'minutes').format(),
    // }
    // if (selected.od) {
    //   slot.end = moment(selected.start).utc().add(selected.od, 'minutes').format()
    // }
    if (account && account.type === 'organisation') {
      getOrganisationMemberships()
    } else {
      setOrgMemberships(null)
    }
    // getPrices(slot)

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [account])

  const goHome = () => {
    dispatch({
      type: 'CLEAR_RESERVATION',
      payload: null,
    })
    setExtraItems()
    setItems([])
    setExtraItemsPrice(0)
    history.push(appconfig.pathPrefix + '/')
  }

  const redeemGiftcode = async () => {
    if (giftcode) {
      const isAlready = membershipprices.find((x) => x.code === giftcode)
      if (isAlready) return { error: true, message: 'not_valid_code' }
      setCheckingGiftcode(true)
      setPricesCheck(true)
      firebase.functions().region = 'europe-west1'
      const fn = appconfig.istest ? 'testmemberships-checkgiftcode' : 'memberships-checkgiftcode'
      let checkGiftcode = firebase.functions().httpsCallable(fn)
      try {
        const giftcodeObject = {
          customerid: appconfig.accountkey,
          code: giftcode,
          type: 'courtreservation',
          duration: selected.duration,
          // the court getPrice priced, so the discount is off the price the customer sees
          resourceId: pricedResourceId(selected),
          start: selected.start,
          end: selected.end,
        }
        const response = await checkGiftcode(giftcodeObject)
        // alert(JSON.stringify(response.data, null, 2))
        // eslint-disable-next-line no-unused-vars
        const { type, value, checksum, reason } = response.data
        if (type === 'reduction') {
          // A number, not toFixed's string: the price is added to extras and multiplied by places.
          const _p = Number((selected.price * value).toFixed(2))
          membershipprices.push({ pricing: 'Etukoodi', price: _p, code: giftcode })
          setGiftcoderedeem(giftcode)
          updateItemPricing(membershipprices)
          setPaymentSummary(false, true, false, false, false)
        } else if (type === 'price') {
          membershipprices.push({ pricing: 'Etukoodi', price: value, code: giftcode })
          setGiftcoderedeem(giftcode)
          updateItemPricing(membershipprices)
          setPaymentSummary(false, true, false, false, false)
        } else if (reason) {
          setGiftcode('')
          alert(reason)
        }
      } catch (error) {
        // console.log(error)
        setGiftcode('')
        alert(error.message)
      }
    }
    setPricesCheck(false)
    setCheckingGiftcode(false)
  }

  const createReservation = async (selectedPayments) => {
    // The slot can finish while the user is still on the payment step. The
    // backend rejects it too, but there is no point making the round trip.
    if (isReservationEndInPast(selected, gtime)) {
      setLoading(false)
      setErrorNotification({ text: t('booking_time_passed') })
      return
    }
    if (!isValidMultiAmount(selected, multiAmounts)) {
      setLoading(false)
      setErrorNotification({ text: t('booking_amount_invalid') })
      return
    }
    setLoading(true)
    const isReducePriced = selected.overridecost ? true : false
    const _resource = { ...selected }
    delete _resource.start
    delete _resource.duration
    delete _resource.overridecost
    // Always sent for a merged court, from the same state Payments charges for. Setting it only
    // when the picker changed left it undefined for a customer who kept the default 1 (or got no
    // picker because one place was free), and createmultiv3 then reserved no real court and
    // booked the merged court's own id instead.
    if (_resource.multiresource) _resource.multiamount = multiAmounts
    _resource.locationid = appconfig.accountkey
    const reservationObject = {
      start: selected.start,
      duration: selected.duration,
      resource: _resource,
      paymentmethod: selectedPayments, // online [{ type }]
      reducedprice: isReducePriced,
      usernote,
      checksum,
    }
    if (selected.items) {
      reservationObject.items = selected.items.map((x) => {
        const _x = { ...x }
        delete _x.amounts
        return _x
      })
    }
    if (account) {
      if (account.type === 'organisation') {
        reservationObject.organisation = account
      }
    }
    if (isReducePriced && selected.general) reservationObject.genp = selected.general.price
    if (selectedmembership) {
      reservationObject.membership = selectedmembership
    }
    if (giftcoderedeem) {
      reservationObject.giftcode = giftcode
    }

    const affiliate = getAffiliate(cookies)
    if (affiliate) {
      reservationObject.affiliate = affiliate
    }

    const shouldRedict = selectedPayments.find((x) => x.type === 'online' && x.charged > 0)
    const shouldRenderOptions = selectedPayments.find((x) => x.type === 'online' && x.charged > 0)
    firebase.functions().region = 'europe-west1'
    const fn = appconfig.istest ? 'testreservations-createmultiv3' : 'reservations-createmultiv3'
    const createReservationCall = firebase.functions().httpsCallable(fn)
    try {
      let response = await createReservationCall(reservationObject)
      if (response.data.error) {
        setLoading(false)
        setErrorNotification(response.data.error)
      } else if (shouldRenderOptions) {
        setCreatedReservation(response.data)
        setRenderPayments(true)
      } else if (shouldRedict) {
        setCreatedReservation(response.data)
        setRedirect(true)
      } else if (isGuestCheckout) {
        // guests cannot see /reservations: show an inline confirmation instead
        setLoading(false)
        setGuestBookingDone(true)
      } else {
        history.push(appconfig.pathPrefix + '/reservations')
      }
    } catch (error) {
      if (isGuestCheckout) {
        setErrorNotification(t('guest_error_generic'))
      } else {
        alert(error.message)
      }
      // console.log(error)
      setLoading(false)
    }
  }

  const cancelReservation = async (id, locationid) => {
    setLoading(true)
    firebase.functions().region = 'europe-west1'
    const fn = appconfig.istest ? 'testreservations-cancelv2' : 'reservations-cancelv2'
    const cancel = firebase.functions().httpsCallable(fn)
    try {
      const response = await cancel({ id, locationid })
      setLoading(false)
      if (response.data.error) {
        alert(response.data.message)
      }
      history.push(appconfig.pathPrefix + '/')
    } catch (error) {
      setLoading(false)
      alert(error.message)
    }
  }

  if (!selected) {
    return <Redirect to={appconfig.pathPrefix + '/'} />
  }

  if (guestBookingDone) {
    return (
      <div className='full-page-background'>
        <Container className='login-dialog'>
          <Row>
            <Col md='8' className='mx-auto'>
              <Card>
                <CardHeader tag='h4'>{t('guest_booking_confirmed_title')}</CardHeader>
                <CardBody>
                  <CardText>{t('guest_booking_confirmed_text')}</CardText>
                  <Button color='primary' onClick={() => goHome()}>
                    {t('close')}
                  </Button>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    )
  }

  if (renderPayments) {
    return (
      <PaymentOptions
        selectedGw={'pc'}
        provider={onlinepaymentprovider}
        disabledmethods={appconfig.disabledpaymentmethods || []}
        showConfirmation={appconfig.bypasspreliminary ? false : true}
        confirmationtype={'reservation'}
        onCancel={cancelReservation}
        cancellable={createdReservation}
        forwardToPaytrail={appconfig.forwardToPaytrail}
      />
    )
  } else if (redirect) {
    return <PaymentRedirect selectedGw={'pc'} />
  }

  if (bl) {
    return (
      <div className='full-page-background'>
        <Container className='login-dialog'>
          <Row>
            <Col md='8' className='mx-auto'>
              <Card>
                <CardHeader tag='h4'>{t('blocked_header')}</CardHeader>
                <CardBody>
                  <CardTitle tag='h5'>{blMessage || t('blocked_message')}</CardTitle>
                  <Button size='small' color='link' className='text-muted' onClick={() => goHome()}>
                    <ChevronLeftIcon /> {t('back_to_reservation')}
                  </Button>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    )
  }

  const getNoteRow = () => {
    return (
      <Row className={'loose'}>
        <Col>
          <FormGroup className='loose-form'>
            <Label for='usernote'>{t('usernote')}</Label>
            <Input
              type='text'
              name='usernote'
              id='usernote'
              value={usernote || ''}
              placeholder=''
              onChange={(event) => setUserNote(event.target.value)}
            />
          </FormGroup>
        </Col>
      </Row>
    )
  }

  const _getExtraResourceData = (key) => {
    const item = items.find((x) => x.key === key)
    if(!item) return null
    const res = item.courts[0]
    const time = res.times ? res.times[0] : null
    const { displayName, start, id } = res
    const { price, duration } = time || {}
    return { displayName, start, price: Math.round(price * 100), duration, resourceid: id, key, type: 'resource' }
  }

  const updateExtraItem = (id, amount) => {
    console.log('updateExtraItem', id, amount)
    const item = items.find((x) => x.id === id)
    console.log('extra found item?', item)

    if (item) {
      if (!selected.items) selected.items = []
      const _selectedItems = [...selected.items]
      console.log('extra _selectedItems after ...', _selectedItems)
      // update seleted item
      const _item = _selectedItems.find((x) => x.item.id === item.id)
      console.log('extra did found _item?', _item)
      if (_item) {
        if (amount === 0) {
          console.log('extra removing item', _selectedItems.findIndex((x) => x.item.id === item.id))
          _selectedItems.splice(
            _selectedItems.findIndex((x) => x.item.id === item.id),
            1
          )
        } else {
          _item.amount = amount
        }
      } else {
        _selectedItems.push({ item, amount })
      }
      console.log('extra _selectedItems', _selectedItems)
      // update extra prices
      selected.extraprice = _selectedItems.reduce((a, cur) => a + cur.item.price * cur.amount, 0) / 100
      selected.items = _selectedItems
      // console.log('selected', selected.extraprice, selected.items)
      setExtraItemsPrice(selected.extraprice)
      // setExtraItems({ ...extraItems, [item.id]: _p })
    }
  }

  const addExtraResource = (key, slot) => {
    console.log('addExtraResource', key, slot)
    if (!slot) {
      // remove extra resource
      if (selected.items) {
        console.log('remove extra resource', key, selected.items)
        const _selectedItems = [...selected.items]
        const _item = _selectedItems.find((x) => x.item.key === key)
        if (_item) {
          _selectedItems.splice(
            _selectedItems.findIndex((x) => x.item.key === key),
            1
          )
        }
        selected.items = _selectedItems
        selected.extraprice = _selectedItems.reduce((a, cur) => a + cur.item.price * cur.amount, 0) / 100
        setExtraItemsPrice(selected.extraprice)
      }
      return
    } else {
      const item = _getExtraResourceData(key)
      console.log('addExtraResource', item)
      if (item) {
        if (!selected.items) selected.items = []
        const _selectedItems = [...selected.items]
        // check if item already exists
        const _item = _selectedItems.find((x) => x.item.id === item.id)
        if (!_item) {
          _selectedItems.push({ item, amount: 1 })
        } else {
          return
        }
        console.log('extra _selectedItems', _selectedItems)
        selected.extraprice = _selectedItems.reduce((a, cur) => a + cur.item.price * cur.amount, 0) / 100
        selected.items = _selectedItems
        setExtraItemsPrice(selected.extraprice)
      }
    }
    return
  }

  if (!selected || (selected && !selected.items)) {
    selected.extraprice = 0
  }

  const getExtrasRow = () => {
    console.log('getExtrasRow', items)
    const extraResources = items.filter((x) => x.type === 'resource')
    const extraRentals = items.filter((x) => x.type !== 'resource')
    if ((extraRentals && extraRentals.length > 0) || (extraResources && extraResources.length > 0)) {
      return (
        <React.Fragment>
          <Row>
            <Col xs={12}>
              <Label for='items'>{t('available_for_this_reservation')}</Label>
            </Col>
          </Row>
          <Row>
          {extraRentals.map((item) => {
            return  <Col xs={6} sm={6} md={4} key={item.id}><ExtraProduct key={item.id} product={item} onChange={(id, amount) => updateExtraItem(id, amount)} showCard={true}/></Col>
          })}
          {extraResources.map((resource) => {
            return <Col xs={6} sm={6} md={4} key={resource.id}><ExtraResource resource={resource} onChange={(key, slot) => addExtraResource(key, slot)} /></Col>
          })}
          </Row>
        </React.Fragment>
      )
    }
    return null
  }

  const getGiftcodeRow = () => {
    return (
      <Row className={'loose'}>
        <Col xs={4} sm={3}>
          <div onClick={() => toggleGiftcode()}>
            {giftcodeOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            <Label for='giftcode'>{t('giftcode')}</Label>
          </div>
          <Collapse in={giftcodeOpen}>
            <FormGroup className='loose-form'>
              <Input
                bsSize={'sm'}
                type='text'
                name='giftcode'
                id='giftcode'
                value={giftcode || ''}
                placeholder=''
                onChange={(event) => setGiftcode(event.target.value.toUpperCase())}
              />
            </FormGroup>
            {giftcode ? (
              <Button
                onClick={() => redeemGiftcode()}
                color={'info'}
                disabled={giftcode.length < 3 || checkingGiftcode}
              >
                {checkingGiftcode ? <Spinner size={'sm'} /> : t('redeem_giftcode')}
              </Button>
            ) : null}
          </Collapse>
        </Col>
      </Row>
    )
  }

  const onAccountChange = (e) => {
    setAccount(e)
  }
  
  console.log('DEBUG selected', selected)
  let ready = !pricescheck && membershipprices && loaded && initdone
  if (appconfig.mandatoryextra && selected.isflight) {
    if (selected.items && selected.items.length > 0) {
      ready = ready && true
    } else {
      ready = false
    }
  }
  if (selected.isflight) {
    selected.price = 0
  }

  if (appconfig.noonlinepayment && appconfig.noonlinepayment.includes(selected.resourceId)) {
    unallowedmethods.push('online')
  }

  let amountSelection = false
  if (selected.amountofresources && selected.amountofresources > 1) {
    amountSelection = true
  }
    
  return (
    <React.Fragment>
      <div className='full-page-background'>
        <Container className='login-dialog'>
          <Row>
            <Col md='8' className='mx-auto'>
              <Card>
                <CardHeader tag='h4'>
                  <Row>
                    <Col>
                      {t('reservation_confirmation')}
                    </Col>
                    <Col className={'text-right'}>
                      {appconfig.allowcreatematches ? (
                      <Button size='sm' color='info' onClick={() => history.push(appconfig.pathPrefix + '/matchreservation')}>
                        {t('create_match')}
                        </Button>) : null}{' '}
                    </Col>
                  </Row>
                </CardHeader>
                <CardBody>
                  {rows && rows.length > 0 ? (
                    rows.map((r, i) => 
                    <ReservationItem reservation={r} key={r.id} memberships={memberships} orgMemberships={orgMemberships} account={account} />
                    )
                  ) : null}
                  <Row>
                    <Col xs={12} md={6} ><CardTitle tag='h5'>{selected.displayName}</CardTitle></Col>
                    {selected.sponsor ? (
                      <Col xs={12} md={6} className={width > 768 ? 'text-right' : ''}><img src={selected.sponsor} alt='courtsponsor' style={{ maxWidth: 290, marginBottom: 10 }} /></Col>) : null}
                  </Row>
                  {organisations && organisations.length > 0 ? (
                    <OrganisationSelect organisations={organisations} onChange={onAccountChange} />
                  ) : null}
                  <Divider />

                  <Row className={'loose'} key={'day'}>
                    <Col>{t('day')}</Col>
                    <Col style={{ textTransform: 'capitalize' }} className={'text-right'}>
                      {moment(selected.start).utc().format('dddd D.M.YYYY')}
                    </Col>
                  </Row>
                  <Divider />
                  <Row className={'loose'} key={'time'}>
                    <Col>{t('time')}</Col>
                    <Col className={'text-right'}>{moment(selected.start).utc().format('H:mm')}</Col>
                  </Row>
                  <Divider />
                  {!selected.isflight ? (
                  <Row className={'loose'} key={'duration'}>
                    <Col>{t('duration')}</Col>
                    <Col className={'text-right'}>{selected.duration} min</Col>
                    </Row>
                  ) : null}
                  {amountSelection ? (
                  <><Divider />
                    <AmountOfReseourcesSelection maxamount={selected.amountofresources} title={t('amount')} onChange={handleMultiAmountsChange} disabled={disabledSelections} /></>
                  ) : null}
                  {selected.customeralert ? (   
                  <>
                  <Divider />
                  <Row className={'loose'} key={'customeralert'}>
                    <Col className={'text-left'}><Alert style={{ marginBottom: 0 }}>{selected.customeralert}</Alert></Col>
                  </Row>
                  </>
                    ) : null}
                  <Divider />
                  <PriceRow
                    pricescheck={pricescheck}
                    membershipprices={membershipprices}
                    selected={selected}
                    t={t}
                    ignorecourtprice={selected.isflight}
                    multipleamount={multiAmounts}
                  />
                  {/* {pricescheck ? (
                    <Spinner size='sm' />
                  ) : membershipprices ? (
                    membershipprices.map((p, i) => {
                      return (
                        <Row key={'membership-prices-' + i} className={'loose'}>
                          <Col>{p.pricing === 'general' ? t('price') : p.pricing}</Col>
                          <Col className={'text-right'}>
                            {i >= 1 ? (
                              <s>{p.price.toFixed(2).replace('.', ',')} €</s>
                            ) : (
                              p.price.toFixed(2).replace('.', ',') + ' €'
                            )}
                            {p.lastminute ? ' ' + t('lastminute_discount') : ''}
                          </Col>
                        </Row>
                      )
                    })
                  ) : (
                    <Row className={'loose'} key={'price'}>
                      <Col>{t('price')}</Col>
                      <Col className={'text-right'}>{selected.price.toFixed(2).replace('.', ',')} €</Col>
                    </Row>
                  )} */}
                  <Divider />
                  {getExtrasRow()}
                  {selected.extraprice ? (
                    <React.Fragment>
                      {selected.extraprice > 0 && selected.items && selected.items.length > 0 ? selected.items.map((i) => (
                        <Row className={'loose'} key={'extraitem-' + i.item.id}>
                          <Col>{i.item.displayName} x {i.amount}</Col>
                          <Col className={'text-right'}>{((i.item.price * i.amount) / 100).toFixed(2).replace('.', ',')} €</Col>
                        </Row>
                      )) : null}
                        
                      {/* <Row className={'loose'} key={'extraprice-exts'}>
                        <Col></Col>
                        <Col className={'text-right'}>{selected.extraprice.toFixed(2).replace('.', ',')} €</Col>
                      </Row> */}
                      {/* The same sum Payments charges below, amount of places included. */}
                      <Row className={'loose'} key={'extraprice-tot'}>
                        <Col>{t('total')}</Col>
                        <Col className={'text-right'}>
                          {((Number(selected.price) + Number(selected.extraprice)) * multiAmounts).toFixed(2).replace('.', ',')} €
                        </Col>
                      </Row>
                    </React.Fragment>
                  ) : null}
                  <Divider />
                  {getNoteRow()}
                  <Divider />
                  {getGiftcodeRow()}
                  
                  {isGuestCheckout ? (
                    <CardText>
                      <small className='text-muted'>{t('guest_nonrefundable_notice')}</small>
                    </CardText>
                  ) : (
                    <CardText>
                      <small className='text-muted'>
                        {t('cancellation_info').replaceAll('{CANCELLIMIT}', appconfig.cancellimit || '24')}
                        <br />
                        {t('cancellation_return')}{' '}
                      </small>
                    </CardText>
                  )}
                  {isGuestCheckout ? (
                    <GuestContactForm auth={auth} profile={profile} onSaved={() => setGuestInfoSaved(true)} />
                  ) : null}
                  {/* {accounts && accounts.length > 0 ? (
                    <React.Fragment>
                      <Divider style={{marginBottom: 10 }} />
                      <AccountSelector accounts={accounts} setAccount={setAccount} />
                      <Divider />
                    </React.Fragment>
                  ) : null} */}

                  <Payments
                    benefitPurchase={{ collection: 'reservations', customerid: appconfig.accountkey, resourceIds: selected.multiresource && Array.isArray(selected.resourceIds) && selected.resourceIds.length > 0 ? selected.resourceIds : [selected.resourceId] }}
                    price={(selected.price + (selected.extraprice ? selected.extraprice : 0) ) * multiAmounts}
                    selecttype='reservation'
                    duration={selected.duration}
                    sport={selected.sport}
                    unallowedmethods={unallowedmethods}
                    nooverridemetohods={isGuestCheckout ? unallowedmethods : undefined}
                    anonymous={isGuestCheckout}
                    buttonText={
                      (payments && payments.find((p) => p.type === 'cashier')) || selected.price === 0
                        ? t('reserve')
                        : t('reserve_and_pay')
                    }
                    buttonAction={createReservation}
                    errorNotification={errorNotification}
                    setPaymentProvider={setPaymentProvider}
                    ready={ready && guestReady}
                    businessAccount={
                      account ? account.type === 'organisation' : false
                    }
                    onSelectionsDisabled={(disabled) => setDisabledSelections(disabled)}
                  />
                  <Row>
                    <Col>
                    <Button
                      size='small'
                      color='link'
                      className='text-muted'
                      onClick={() => goHome()}
                    >
                      <ChevronLeftIcon /> {t('back_to_reservation')}
                        </Button>
                      </Col>
                      <Col className='text-right'>
                      <Button color='link' onClick={tcToggle}>
                        {t('reservation_accepttandc')}
                      </Button>
                    </Col>
                  </Row>  
                </CardBody>
              </Card>
            </Col>
          </Row>
          {/* {rows && rows.length > 0 ? (
            <pre>{JSON.stringify(rows, null, 2)}</pre>
          ) : <pre>{JSON.stringify(selected, null, 2)}</pre>} */}
        </Container>
        <TermsModal isOpen={tcmodal} toggle={tcToggle} defaultLanguage={'fi'} appconfig={appconfig} />
      </div>
    </React.Fragment>
  )
  // }
}

export default withAppconfig(enhance(ReservationScreen))
